import { createSelector } from 'reselect';
import { getAppNowUtcProp, isDateTimeUtcOlderThan23Hours } from '@mews-commander/utils';
import { createOnMessage, createOnOpen } from '../core/websockets/actionFactories';
import { handleExpiredSession, onClose, onError } from '../core/websockets/actions';
import createMessageHandler from '../core/websockets/createMessageHandler';
import {
    spaceUpdatesHandler,
    subscribeResourceUpdates,
    SUBSCRIPTION_SPACES,
} from '../core/websockets/eventHandlers/spaces';
import { getServerNowUtc } from '../modules/app/reducers/configuration';
import {
    subscribeNotificationUpdates,
    SUBSCRIPTION_NOTIFICATIONS,
} from '../modules/notifications/actions/subscriptions';
import { notificationUpdatesHandler } from '../modules/notifications/eventHandlers';
import { subscribeReservationUpdates, SUBSCRIPTION_RESERVATIONS } from '../modules/timeline/actions/subscriptions';
import { reservationUpdatesHandler } from '../modules/timeline/eventHandlers';

const messageHandler = createMessageHandler([
    notificationUpdatesHandler,
    reservationUpdatesHandler,
    spaceUpdatesHandler,
]);

const subscriptions = {
    [SUBSCRIPTION_NOTIFICATIONS]: subscribeNotificationUpdates,
    [SUBSCRIPTION_SPACES]: subscribeResourceUpdates,
    [SUBSCRIPTION_RESERVATIONS]: subscribeReservationUpdates,
};

const isSessionExpired = createSelector(getAppNowUtcProp, getServerNowUtc, isDateTimeUtcOlderThan23Hours);

export default {
    onOpen: createOnOpen(subscriptions),
    onMessage: createOnMessage(messageHandler),
    onClose,
    onError,
    isSessionExpired,
    handleExpiredSession,
};
